import { z } from "zod"

export const SessionObjectSchema = z.object({
  xAuth: z.string(),
  remoteURL: z.string().url(),
  launcherURL: z.string().url(),
  adminURL: z.string().url(),
  email: z.string().email(),
  accountID: z.number().int(),
  userID: z.number().int(),
  launcherID: z.string(),
  jSessionID: z.string(),
  isValidSessionData: z.boolean().optional(),
  dynamo: z.object({
    url: z.string().url(),
    id: z.string(),
    token: z.string(),
    ttl: z.number().int(),
  }),
})
export type TSessionObject = z.infer<typeof SessionObjectSchema>

export const AppDataCookieSchema = SessionObjectSchema
// z.object({
// urls: z.object({
//   launcher: z.coerce.string().url(),
//   remote: z.coerce.string().url(),
//   dynamo: z.coerce.string().url(),
// }),
// user: z.object({
//   xAuthToken: z.coerce.string(),
//   email: z.coerce.string().email(),
//   id: z.coerce.number().int(),
//   accountId: z.coerce.number().int(),
//   name: z.coerce.string(),
//   lastName: z.coerce.string(),
//   companyName: z.coerce.string(),
//   isOwner: z.coerce.boolean(),
//   isAdmin: z.coerce.boolean(),
//   fullName: z.coerce.string(),
//   accountSmsEnabled: z.coerce.boolean(),
//   jSessionID: z.coerce.string(),
//   launcherID: z.coerce.string(),
// }),
// dynamo: z.object({
//   ttl: z.coerce.number().int(),
//   id: z.coerce.number().int(),
//   token: z.coerce.string(),
// }),
// ids: z.object({
// jSessionID: z.coerce.string(),
// launcherID: z.coerce.string(),
// }),
// })
export type TAppDataCookie = z.infer<typeof AppDataCookieSchema>

export const AppDataObjectSchema = z.object({
  appData: AppDataCookieSchema,
})
export type TAppDataObject = z.infer<typeof AppDataObjectSchema>
